// extracted by mini-css-extract-plugin
export default {"root":"WishlistHeart_root__Y1jRc","selected":"WishlistHeart_selected__VPRFC"};